import { hydrate, render } from "react-dom";
import React from "react";
// urql
import { Provider as UrqlProvider } from "urql";
import client from "./urql/client";
//redux
import { Provider as ReduxProvider } from "react-redux";
import { store, persistor } from "./state/store";
import { PersistGate } from "redux-persist/integration/react";
// app
import StagingContext, { DRAFT, LIVE } from "./context/StagingContext";
import "../scss/app.module.scss";
import LoadingScreen from "./components/Screens/LoadingScreen";
import log from "./utils/log";
import { NavigationContextComponent } from "./context/NavigationContext";
import { PromptContextComponent } from "./context/PromptContext";

// polyfills
import loadPolyfills from "polyfill-io-loader!?Promise,URL,WeakSet,Array.prototype.includes,CustomEvent,Object.entries,Object.values";
import ErrorMessage from "./components/ErrorMessage";

// detect required polyfills before loading app
loadPolyfills(() => {
  // check for staging and append to api url
  const params = new URLSearchParams(location.search);
  const stage = params.get("stage") === "Stage" ? DRAFT : LIVE;

  const RoutesPromise = import(
    /* webpackChunkName: 'Routes' */ "./components/Routes"
  );

  Promise.all([RoutesPromise])
    .then(([{ default: Routes }]) => {
      const App = () => {
        return (
          <StagingContext.Provider value={stage}>
            <ReduxProvider store={store}>
              <PromptContextComponent>
                <PersistGate loading={<LoadingScreen />} persistor={persistor}>
                  <UrqlProvider value={client}>
                    <NavigationContextComponent>
                      <Routes />
                    </NavigationContextComponent>
                  </UrqlProvider>
                </PersistGate>
              </PromptContextComponent>
            </ReduxProvider>
          </StagingContext.Provider>
        );
      };

      hydrate(<App />, document.getElementById("root"));
    })
    .catch((e) => {
      log.error(e);
      render(<ErrorMessage error={e} />, document.getElementById("root"));
    });
});
